<template>
  <layout-main-inner title="抽样管理详情">
    <div slot="action">
      <button-back />
      <!-- <el-button
        v-if="permission.LVL2"
        type="primary"
        @click="update">
        编辑
      </el-button> -->
    </div>
    <layout-card-wrap hasSlot>
      <template slot="title">企业信息</template>
      <el-form
        v-loading="loading"
        label-position="top"
        label-width="110px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="企业名称：">
              {{ info.vendorName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证照号码：">
              {{ info.unifiedCreditCode }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人：">
              {{ info.vendorPerson }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="联系电话：">
              {{ info.vendorPhone }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <layout-card-wrap hasSlot>
      <template slot="title">样品信息</template>
      <el-form
        v-loading="loading"
        label-position="top"
        label-width="110px">
        <el-row
          :gutter="20">
          <el-col :span="8">
            <el-form-item label="样品名称：">
              {{ info.productName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产地：">
              {{ info.originRegion }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="样本数量：">
              {{ info.sampleCount }}份
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="抽样费用：">
              {{ info.sampleCost }}元
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="抽样时间：">
              {{ info.createdTime | dateformat() }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="抽样地址：">
              {{ info.sampleProvinceName }}-{{ info.sampleCityName }}-{{ info.sampleAreaName }}-{{ info.sampleAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="样品码：">
              <el-table
                border
                :data="info.sampleDetails">
                <el-table-column
                  label="标签码"
                  prop="tagCode"></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <layout-card-wrap hasSlot>
      <template slot="title">生产信息</template>
      <el-form
        v-loading="loading"
        label-position="top"
        label-width="145px">
        <el-row
          :gutter="20">
          <el-col :span="8">
            <el-form-item label="进货/生产数量：">
              {{ info.productionCount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进货/生产日期：">
              {{ info.productionTime | dateformat() }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产业园/市场：">
              {{ info.industrialPark }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生产/供货商：">
              {{ info.producer }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生产/供货商地址：">
              {{ info.producerAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生产/供货商联系人：">
              {{ info.producerPerson }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <layout-card-wrap hasSlot>
      <template slot="title">
        <span>快检结果</span>
      </template>
      <el-form
        v-loading="loading"
        label-position="top"
        label-width="145px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="快检报告：">
              <el-image
                style="width: 70px; height: 98.7px"
                :src="info.reportImageFile"
                :preview-src-list="[info.reportImageFile]">
              </el-image>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SampleDetail',
  components: { },
  data() {
    return {
      loading: false,
      info: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    if (this.$route.query.inspectionSampleId) {
      this.getseaport()
    }
  },
  methods: {
    getseaport() {
      this.loading = true
      this.$store.dispatch('account/getsample', {
        payload: this.$route.query,
        success: (res) => {
          this.loading = false
          this.info = {
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
